module.exports = __webpack_public_path__ + "fonts/duo_ico@2x.f66edb7ed4dba7c20c81e00026944f7b.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/duo_ico@2x.png
// module id = 732
// module chunks = 9